import axios from 'axios';
import url from '../url.js';

const API_BASE = `${url.backendHost}api`;

const dmService = {
  // Get DM settings for current user
  getDmSettings: async (userId) => {
    const response = await axios.get(`${API_BASE}/users/${userId}/dm-settings`, {
      withCredentials: true
    });
    return response.data;
  },

  // Update DM settings
  updateDmSettings: async (userId, settings) => {
    const response = await axios.put(`${API_BASE}/users/${userId}/dm-settings`, settings, {
      withCredentials: true
    });
    return response.data;
  },

  // Apply for DM with a user
  applyForDm: async (openerId) => {
    const response = await axios.post(`${API_BASE}/dm-open/${openerId}/apply`, {}, {
      withCredentials: true
    });
    return response.data;
  }
};

export default dmService;
